import React from 'react';
import { FONT_BODY } from './theme';
import { CtaButton } from './ui';
import { ArrowIcon, PlayIcon, CheckCircleIcon } from './icons';
import DashboardMock from './DashboardMock';

const TRUST_POINTS = ['Free platform', 'Free roadmap', 'No card needed'];

const Hero: React.FC<{ onEarlyAccess: () => void; onVideo: () => void }> = ({ onEarlyAccess, onVideo }) => (
  <section
    id="top"
    style={{ position: 'relative', padding: 'clamp(30px,4vw,54px) clamp(16px,4vw,30px) clamp(30px,4vw,54px)', overflow: 'clip' }}
  >
    <div
      style={{
        position: 'absolute',
        top: -30,
        right: '8%',
        width: 300,
        height: 300,
        borderRadius: '50%',
        background: 'radial-gradient(circle at 45% 45%,rgba(167,139,250,.5),rgba(255,255,255,0) 70%)',
        pointerEvents: 'none',
        animation: 'sm1p-drift 15s ease-in-out infinite',
      }}
    />
    <div
      style={{
        position: 'absolute',
        top: 10,
        right: '26%',
        width: 250,
        height: 250,
        borderRadius: '50%',
        background: 'radial-gradient(circle at 50% 50%,rgba(96,165,250,.42),rgba(255,255,255,0) 70%)',
        pointerEvents: 'none',
      }}
    />
    <div
      style={{
        position: 'absolute',
        top: 210,
        left: '43%',
        width: 250,
        height: 250,
        borderRadius: '50%',
        background: 'radial-gradient(circle at 50% 50%,rgba(191,219,254,.55),rgba(255,255,255,0) 72%)',
        pointerEvents: 'none',
      }}
    />

    <div
      className="sm1p-hero-grid"
      style={{
        position: 'relative',
        maxWidth: 1180,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,420px),1fr))',
        gap: 'clamp(24px,3vw,40px)',
        alignItems: 'center',
      }}
    >
      <div style={{ minWidth: 0 }}>
        <span
          style={{
            display: 'inline-block',
            background: '#E0EDFF',
            borderRadius: 999,
            padding: '8px 17px',
            font: `700 10.5px ${FONT_BODY}`,
            letterSpacing: '.15em',
            textTransform: 'uppercase',
            color: '#2563EB',
          }}
        >
          AI Workforce for Schools
        </span>
        <h1
          style={{
            font: `800 clamp(32px,4.5vw,52px)/1.1 ${FONT_BODY}`,
            letterSpacing: '-.038em',
            margin: '18px 0 0',
            color: '#0F172A',
            textWrap: 'balance',
          }}
        >
          Your school.
          <br />
          <span
            style={{
              background: 'linear-gradient(92deg,#2563EB,#60A5FA 50%,#818CF8)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            Your AI workforce.
          </span>
        </h1>
        <p
          style={{
            font: `400 clamp(15px,1.35vw,17px)/1.65 ${FONT_BODY}`,
            color: '#475569',
            margin: '18px 0 0',
            maxWidth: '44ch',
          }}
        >
          Not another AI tool. An AI workforce of 30+ agents running a 3-year strategic roadmap with you — across
          admissions, marketing, academics, parents, fees and operations. The ambition: double your admissions in three
          years.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, margin: '24px 0 0' }}>
          <CtaButton variant="hero" onClick={onEarlyAccess}>
            GET EARLY ACCESS
            <ArrowIcon size={16} />
          </CtaButton>
          <button
            type="button"
            onClick={onVideo}
            className="sm1p-btn-video"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 11,
              cursor: 'pointer',
              background: '#F4F8FE',
              border: '1px solid #E3EBF7',
              color: '#0F172A',
              borderRadius: 999,
              padding: '10px 24px 10px 10px',
              font: `700 15.5px ${FONT_BODY}`,
            }}
          >
            <span
              style={{
                width: 34,
                height: 34,
                borderRadius: '50%',
                background: '#2563EB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 'none',
              }}
            >
              <PlayIcon />
            </span>
            Watch Video
          </button>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 24px', margin: '22px 0 0' }}>
          {TRUST_POINTS.map((t) => (
            <span
              key={t}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, font: `500 14px ${FONT_BODY}`, color: '#334155' }}
            >
              <CheckCircleIcon />
              {t}
            </span>
          ))}
        </div>
      </div>

      <DashboardMock />
    </div>
  </section>
);

export default Hero;
